
import '../vendor/autoComplete-1.0.4/auto-complete.js';



(() => {
	const forms = document.querySelectorAll('.searchbox form');
	Array.from(forms).forEach(form => {
		
		form.addEventListener('submit', event => event.preventDefault() );
		
		const search_url = form.getAttribute('action');
		const selector = '#'+ form.querySelector('input[type=search]').getAttribute('id');
		
		new autoComplete({
			selector: selector,
			minChars: 1,
			source: (term, suggest) => {
				const options = {
					headers: new Headers(),
				};
				options.headers.append('X-Requested-With', 'XMLHttpRequest');
			
				fetch(search_url +'?s='+ term, options)
					.then(response => response.json())
					.then(json => {
						const suggestions = json;
						suggest(suggestions);
					});
			},
	
			renderItem: (item, search) => {
				search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
				const re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
				const rp = '<span class="em">$1</span>';
				
				
				return `<div class="autocomplete-suggestion" data-href="${ item.permalink }">
						<article class="classes-search-result">
							<a href="${ item.permalink }">
								<div class="ac-thumb">
									<img src="${ item.thumbnail }" alt="${ item.title }" />
								</div>
								<h3 class="ac-title">${ item.title.replace(re, rp) }</h3>
								<div class="ac-categories"><p>${ item.categories.join(' > ') }</div>
							</a>
						</article>
					</div>`;
			},
			
			onSelect: (e, term, item) => {
				e.preventDefault();
				document.location.href = item.dataset.href;
			}
		});
	});
})();